<div class="imp-modal">
  <div class="imp-modal-body">
    <imp-privacy></imp-privacy>>
  </div>
</div>
<div class="imp-modal-background"></div>
